import type {DiffEntryDataWithExtraInfo} from '../../types/commit-types'
import {Diff} from './Diff'
import {useDiffViewSettings} from '../../contexts/DiffViewSettingsContext'
import {noop} from '@github-ui/noop'
import {useRef} from 'react'

interface DiffsProps {
  diffEntryData: DiffEntryDataWithExtraInfo[]
  contextLinePathURL: string
  unselectedFileExtensions?: Set<string>
}

export function SSRDiffs({diffEntryData, contextLinePathURL}: DiffsProps) {
  const diffViewSettings = useDiffViewSettings()
  const diffEntriesToUse = useRef(diffEntryData)

  return (
    <div data-hpc>
      {diffEntryData.map((currentDiffData, index) => {
        return (
          <div key={currentDiffData.pathDigest} className="pt-2 pb-2">
            <Diff
              diffEntryData={diffEntriesToUse}
              index={index}
              splitPreference={diffViewSettings.splitPreference}
              contextLinePathURL={contextLinePathURL}
              recalcTotalHeightOfVirtualWindow={noop}
            />
          </div>
        )
      })}
    </div>
  )
}

try{ SSRDiffs.displayName ||= 'SSRDiffs' } catch {}